import { For, Show } from "solid-js"
import { delayTone, formatAvgDelay } from "../lib/format"
import type { PunctualityStats } from "../lib/types"
import { app } from "../store/app"

function StatBlock(props: { title: string; stats: PunctualityStats; compact?: boolean }) {
  const pct = () => props.stats.onTimePct
  return (
    <div class={`stats-card${props.compact ? " compact" : ""}`}>
      <div class="stats-card-head">
        <strong>{props.title}</strong>
        <span class="muted">{props.stats.vehicles} buses</span>
      </div>
      <div class="stats-row">
        <div>
          <div class="label">on time</div>
          <div class={`value ${pct() == null ? "" : pct()! >= 70 ? "ok" : pct()! >= 50 ? "" : "late"}`}>
            {pct() == null ? "—" : `${pct()}%`}
          </div>
        </div>
        <div>
          <div class="label">avg delay</div>
          <div class={`value ${delayTone(props.stats.avgDelaySec)}`}>
            {formatAvgDelay(props.stats.avgDelaySec)}
          </div>
        </div>
      </div>
      <Show when={!props.compact}>
        <div class="stats-breakdown muted">
          {props.stats.onTime} on time · {props.stats.late} late · {props.stats.early} early
        </div>
      </Show>
      <div class="stats-meter">
        <div class="seg ok" style={{ width: `${props.stats.withDelay ? (props.stats.onTime / props.stats.withDelay) * 100 : 0}%` }} />
        <div class="seg late" style={{ width: `${props.stats.withDelay ? (props.stats.late / props.stats.withDelay) * 100 : 0}%` }} />
        <div class="seg early" style={{ width: `${props.stats.withDelay ? (props.stats.early / props.stats.withDelay) * 100 : 0}%` }} />
      </div>
    </div>
  )
}

export function StatsPanel() {
  return (
    <Show when={app.stats()}>
      {(stats) => (
        <section class="stats-panel">
          <StatBlock title="systemwide" stats={stats().overall} />
          <div class="stats-agency-list">
            <For each={stats().agencies}>
              {(agency) => <StatBlock title={agency.name} stats={agency} compact />}
            </For>
          </div>
        </section>
      )}
    </Show>
  )
}
